import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import RequirementsBanner from "@/components/feature/RequirementsBanner";
import HeroSection from "./HeroSection";
import StatsSection from "./StatsSection";
import ServicesSection from "./ServicesSection";
import AboutSection from "./AboutSection";
import ProjectsSection from "./ProjectsSection";
import TestimonialsSection from "./TestimonialsSection";
import CTASection from "./CTASection";
import ContactSection from "./ContactSection";

export default function HomeContent() {
  return (
    <div className="bg-aa-black min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <RequirementsBanner />
        <StatsSection />
        <ServicesSection />
        <AboutSection />
        <ProjectsSection />
        <TestimonialsSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}